// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"c32f144942e992a85a89","303":"c7dce31613a28ae68968","495":"e1e42ac17532e48758cb"}[chunkId] + ".js";
};